/**
 * メインレイアウトコンポーネント
 *
 * アプリケーション全体のレイアウトを管理
 * ヘッダー、サイドバー、メインコンテンツエリアを含む
 */

import { Outlet } from 'react-router-dom';
import Header from './Header';
import ChatBot from '../Chat/ChatBot';
import KofiButton from '../Support/KofiButton';
import { useUser } from '../../contexts/UserContext';

function MainLayout() {
  const { shouldShowAds } = useUser();

  return (
    <div className="min-h-screen bg-gray-50">
      {/* ヘッダー */}
      <Header />

      {/* メインコンテンツエリア */}
      <div className="flex">
        {/* 左側: メインコンテンツ */}
        <main className="flex-1 p-6 lg:pr-[420px]">
          <div className="max-w-4xl mx-auto">
            <Outlet />
          </div>
        </main>

        {/* 右側: チャットボット（デスクトップ） */}
        <aside className="hidden lg:block fixed right-0 top-16 bottom-0 w-[400px] bg-white border-l border-gray-200">
          <ChatBot />
        </aside>
      </div>

      {/* Ko-fi サポートボタン（フローティング） */}
      <KofiButton />

      {/* モバイル用チャットボタン */}
      <MobileChatButton />
    </div>
  );
}

/**
 * モバイル用チャットボタン
 */
function MobileChatButton() {
  return (
    <button
      className="lg:hidden fixed bottom-20 right-4 w-14 h-14 bg-primary text-white rounded-full shadow-lg flex items-center justify-center hover:bg-primary-hover transition-colors z-40"
      onClick={() => {
        // モバイルチャットモーダルを開く（将来実装）
        console.log('モバイルチャットを開く');
      }}
      aria-label="Thothに質問する"
    >
      <img
        src="/knovelo-trans-icon.png"
        alt="Thoth"
        className="w-10 h-10 rounded-full"
      />
    </button>
  );
}

export default MainLayout;
